import { FieldConfig, GenericFieldHTMLAttributes, Field } from 'formik'
import { TextFieldProps, InputLabel } from '@material-ui/core'

import { INPUT_CPF_MASK } from 'src/utils/masks'

import { POSTextMask } from 'src/components'

export type POSFieldCpfProps = GenericFieldHTMLAttributes &
    FieldConfig &
    TextFieldProps

export const POSFieldCpf = ({ label, ...props }: POSFieldCpfProps) => (
    <>
        <InputLabel>{label}</InputLabel>
        <Field
            component={POSTextMask}
            mask={INPUT_CPF_MASK}
            variant="filled"
            fullWidth
            inputProps={{
                inputMode: 'numeric',
            }}
            {...props}
        />
    </>
)
